<script setup>
import {defineProps,computed} from "vue";
import {game} from "@/utils/config";

const type = computed(() => game.qxdj)
const props = defineProps({
  orderLst: {
    type: Array,
    default: () => [],
  }
})
</script>

<template>
  <el-card class="order-items" shadow="never" v-for="order in props.orderLst" :key="order.id">
    <template #header>
      <div class="order-items-header">
        <div class="order-sn">
          订单编号：{{ order.ordersn }}
        </div>
        <div class="order-state">
          <div :class="`order-state-item-${order.state === 1?'success':'cancel'}`">
            {{ order.state_text }}
          </div>
        </div>
      </div>
    </template>
    <div class="order-items-body">
      <div class="order-items-body-left" :style="{backgroundImage: `url('${type.order_card}')`}" v-if="order?.goodsItems?.plate === '优惠券'">
        <div>
          <b class="face_value">{{ parseFloat(order.goodsItems.face_value || 0) }}</b>元
        </div>
        <div class="tips">无门槛使用</div>
      </div>
      <div class="order-items-body-left" v-else>
        <el-image :src="order?.goodsItems?.remarks?.order_img" style="width: 100%;height: 75%"/>
      </div>
      <div class="order-items-body-right">
        <h4 class="order-product-name" v-if="order?.goodsItems?.plate === '优惠券'">{{ type.name }}{{ type.coupon_type }}</h4>
        <h4 class="order-product-name" v-else>{{ order?.goodsItems?.goods_name }}</h4>
        <div class="order-items-body-right-content">
          <span>支付里程：</span>{{ order.miles }}里程
        </div>
        <div class="order-items-body-right-content">
          <span>下单时间：</span>{{ order.create_time }}
        </div>
        <div class="order-items-body-right-content">
          <span>充值账户：</span>{{ order.mobile }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<style scoped lang="less">



  .order-items {
    margin-bottom: 15px;
    background: #ffffff url("@/assets/images/order-body.png") no-repeat right bottom;
    background-size: 50px;

    /deep/ .el-card__header {
      padding: 10px;
    }

    .order-items-header {

      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: .8rem;

      .order-state-item-success {
        color: var(--el-color-warning);
      }

      .order-state-item-cancel {
        color: var(--el-color-info);
      }
    }

    .order-items-body {
      display: flex;

      .order-items-body-left {
        flex-basis: 100px;
        width: 100px;
        margin-right: 8px;
        position: relative;
        background-repeat: no-repeat;
        //background-size: 100% 100%;
        background-size: 100px 100px;
        text-align: center;
        color: #6D4923;
        line-height: 85px;

        .tips{
          position: absolute;
          z-index: 999999;
          top: 25px;
          font-size: .8rem;
          width: 100px;
        }

        .face_value {
          font-size: 1.5rem;
        }
      }

      .order-items-body-right {
        line-height: 1.75;

        .order-product-name {
          color: var(--el-color-warning);
        }

        .order-items-body-right-content {
          font-size: .8rem;
        }
      }
    }
  }
</style>
